<div class="modal-header">
    <h4 class="modal-title">{{'notification_itemTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <div class="data-value">
        <label>{{'notification_lblDate' | translate}}</label>
        <div>{{item?.Date | appDate:'datetime'}}</div>
    </div>

    <div class="data-value" *ngIf="isFullContentVisible">
        <label>{{'notification_lblSubject' | translate}}</label>
        <div>{{item?.Subject}}</div>
    </div>

    <div class="data-value" *ngIf="isFullContentVisible">
        <label>{{'notification_lblMessage' | translate}}</label>
        <div [innerHTML]="item?.Message | safeHtml"></div>
    </div>

    <div class="data-value" *ngIf="isShortContentVisible">
        <label>{{'notification_lblShortMessage' | translate}}</label>
        <div>{{item?.ShortMessage}}</div>
    </div>

    <div class="data-value col">
        <label>{{'notification_lblChannels' | translate}}</label>
        <div>
            <div *ngFor="let n of requests">
                {{'notification_channel' + n.Channel | translate}}
                <app-notification-request-status [value]="n.Status"></app-notification-request-status>
            </div>
        </div>
    </div>

    <div class="data-value col">
        <label>{{'notification_lblType' | translate}}</label>
        <div>{{item?.Type}}</div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="close()">{{'close' | translate}}</button>
</div>
